// src/components/ManageDealDrawer/ManageDealDrawerHeader.tsx

import React from 'react';
import styles from '../ManageDealDrawer.module.scss';
import closeIcon from '../../_custom/SideDrawer/close.svg';
import clsx from 'clsx';

type ManageDealDrawerHeaderProps = {
    drawerLabel: string;
    investorName?: JSX.Element | string;
    noBorder?: boolean;
    headerAction?: React.ReactNode;
    onClose?: () => void;
    headerActionStyle?: React.CSSProperties;
    source?: string;
};

export const ManageDealDrawerHeader: React.FC<ManageDealDrawerHeaderProps> = ({
    drawerLabel,
    investorName,
    noBorder,
    headerAction,
    onClose,
    headerActionStyle,
    source,
}) => {
    return (
        <div style={noBorder ? { border: 'none' } : {}} className={styles.DrawerHeading}>
            <div
                className={clsx(styles.DrawerHeadingTitle, {
                    [styles.FilterDrawerHeadingTitle]: source === 'FilterDrawer',
                })}
            >
                {drawerLabel}
                {investorName && <span className={styles.VerticalSeparator}>|</span>}
                {investorName && typeof investorName === 'string' && <span className={styles.CompanyName}>{investorName}</span>}
                {investorName && typeof investorName !== 'string' && investorName}
            </div>
            <div className={styles.HeaderActions}>
                {headerAction && <div style={{ ...headerActionStyle }}>{headerAction}</div>}
                {onClose && <img className={styles.closeIcon} src={closeIcon} alt="close" height="15px" onClick={onClose} />}
            </div>
        </div>
    );
};
